import React from 'react'
import './GISServicesShowcase.css'
import parse from 'html-react-parser'

const services = [
    {
        id: '01',
        title: 'Custom Web Mapping & Spatial Dashboards',
        description:
            `<p>Interactive, high-performance web applications built with MapLibre GL JS, Leaflet, and React. Optimized for visualizing large-scale spatial datasets, dynamic vector tile styling, and real-time data feeds.</p><p>Front-end integration with React and D3.js make for a bespoke and interactive visual experience for users where map layers can be filtered, zoomed, grouped, structured and analyzed in real-time to derive powerful insights. </p>`,
        tags: ['MapLibre GL', 'PostGIS', 'React.js', 'Vector Tiles', 'D3.js'],
        image: './images/portfolio/barcelona_extrusion.png',
        alt: 'Interactive Web Map Dashboard Showcase',
    },
    {
        id: '02',
        title: 'Satellite Remote Sensing & Earth Observation',
        description:
            `<p>An automated workflow conversts a series of Copernicus and ASTER multispectral satellite data into visual Physical Risk Models, helping to pinpoint, manage, and mitigate climate threats before they hit. From broad census tracts down to individual land parcels, our geospatial platform layers complex demographic and environmental data into clear visual insights—enabling you to deploy resources faster and safeguard your assets against flood, heat, and demographic risks.</p><h5>Practical Municipal Applications to Identify Vulnerable Populations:</h5><p>Digitization of catastral and census demographics to identify high-density neighborhoods with vulnerable, elderly populations. Optimize tree canopy expansion, cool pavement projects, and mobile cooling stations exactly where health risks peak and vulnerable populations would benefit.</p><h5>Precision Stormwater & Flash Flood Planning:</h5><p>Integration of satellite surface-imperviousness metrics with parcel-level topography. Pinpoint runoff bottlenecks during extreme precipitation events to prioritize infrastructure investments at the block level.</p><h5>Infrastructure Asset Protection & Capital Allocation:</h5><p>Monitor land surface subsidence, vegetation encroachment, and coastal or riverbank erosion around critical public infrastructure (schools, emergency services, water facilities) to schedule predictive maintenance and secure regional resilience grants.</p><h5>Emergency Preparedness:</h5><p>Layering of climate risk zones with socio-economic vulnerability indicators to channel personnel resources. Provide emergency planning teams with hyper-local evacuation maps and targeted communication strategies ahead of extreme weather events.</p>`,
        tags: ['Rasterio', 'GDAL', 'Python', 'Remote Sensing'],
        image: './images/portfolio/matadepera.gif',
        alt: 'Satellite Remote Sensing Imagery Analysis',
    },
    {
        id: '03',
        title: 'Spatial Database Engineering & API Architecture',
        description:
            'End-to-end spatial database architecture with PostgreSQL/PostGIS, tile server setup (pg_tileserv), and robust REST APIs designed for multi-criteria territorial management and spatial analysis.',
        tags: ['PostgreSQL', 'PostGIS', 'Node.js', 'REST APIs'],
        image: './images/portfolio/arenys_flow_accumulation.png',
        alt: 'Spatial Database and Infrastructure Architecture',
    },
];

const GisServicesShowcase = () => {
    return (
        <section className="gis-showcase">
            <div className="gis-container">
                {/* Section Header */}
                <header className="gis-header">
                    <span className="gis-subtitle">Expertise & Solutions</span>
                    <h2 className="gis-title">GIS & Spatial Software Consulting</h2>
                    <p className="gis-lead">
                        Bridging technical geospatial analysis, database architecture, and interactive web mapping.
                    </p>
                </header>

                {/* Services List */}
                <div className="gis-list">
                    {services.map((service, index) => {
                        const isEven = index % 2 === 0;
                        return (
                            <article
                                key={service.id}
                                className={`gis-item ${isEven ? 'gis-item--even' : 'gis-item--odd'}`}
                            >
                                {/* Image Column */}
                                <div className="gis-media">
                                    <div className="gis-image-wrapper">
                                        <img
                                            src={service.image}
                                            alt={service.alt}
                                            className="gis-image"
                                        />
                                        <div className="gis-image-overlay" />
                                    </div>
                                </div>

                                {/* Content Column */}
                                <div className="gis-content">
                                    <span className="gis-badge">{service.id}</span>
                                    <h3 className="gis-item-title">{service.title}</h3>
                                    {parse(service.description)}

                                    <div className="gis-tags">
                                        {service.tags.map((tag) => (
                                            <span key={tag} className="gis-tag">
                        {tag}
                      </span>
                                        ))}
                                    </div>
                                </div>
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}

export default GisServicesShowcase

